import { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { FileText } from "lucide-react";
import api from "@/lib/api";
import Seo, { orgSchema } from "@/components/Seo";

const SITE = "https://signiastylettoix.com";

export default function PolicyPage() {
    const params = useParams();
    const location = useLocation();
    const slug = params.slug || (location.pathname === "/about" ? "about" : null);
    const [page, setPage] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancelled = false;
        setPage(null); setError(false);
        api.get(`/pages/${slug}`)
            .then((r) => { if (!cancelled) setPage(r.data); })
            .catch(() => { if (!cancelled) setError(true); });
        window.scrollTo(0, 0);
        return () => { cancelled = true; };
    }, [slug]);

    if (error) return <div className="min-h-[60vh] flex items-center justify-center text-[#4a5568]">Page not found. <Link className="underline ml-2" to="/">Home</Link></div>;
    if (!page) return <div className="min-h-[60vh] flex items-center justify-center text-[#4a5568]">Loading…</div>;

    const url = slug === "about" ? `${SITE}/about` : `${SITE}/policies/${slug}`;
    return (
        <>
            <Seo title={page.title} description={page.meta_description} canonical={url}
                schema={{ "@context": "https://schema.org", "@graph": [orgSchema()] }} />
            <section className="pt-12 md:pt-16 pb-16">
                <div className="container-x max-w-[780px]">
                    <p className="eyebrow inline-flex items-center gap-2"><FileText size={12} /> {slug === "about" ? "Company" : "Policies"}</p>
                    <h1 className="font-serif text-[34px] md:text-[46px] leading-[1.1] mt-4" data-testid="policy-h1">{page.h1}</h1>
                    <div className="mt-10 space-y-10">
                        {page.sections.map((s, i) => (
                            <div key={i}>
                                <h2 className="font-serif text-[24px] text-[#003E4D] mb-3">{s.h2}</h2>
                                <div className="text-[15.5px] text-[#333] leading-relaxed space-y-3 [&_a]:text-[#0F6B7D] [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_li]:my-1" dangerouslySetInnerHTML={{ __html: s.body }} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
